import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'gatsby'

import CarouselBanner from '@components/Home/Carousel/CarouselBanner'
import JustInSection from '@components/Home/JustInSection'
import LookBooksSection from '@components/Home/LookBooksSection'
import FeaturedSection from '@components/Home/FeaturedSection'
import CollectionSection from '@components/Home/CollectionSection'
import DiscoverSection from '@components/Home/DiscoverSection'
import SuitYourselfSection from '@components/Home/SuitYourself/SuitYourselfSection'
import DisplayCard from '@components/productcards/DisplayCard'
import QuickBuyModal from '@components/modal/QuickBuyModal'
import QuickBuyContext from '@context/QuickBuyContext'

// assets
import bannerBunny from '@images/Home/banners/agua-fresca-desktop.png'
import mobilebannerBunny from '@images/Home/banners/agua-fresca-mobile.png'
import bannerHenna from '@images/Home/banners/henna-homepage-banner-desktop.webp'
import mobileBannerHenna from '@images/Home/banners/henna-homepage-banner-mobile.webp'
import bannerPalacio from '@images/Home/banners/Homepage-Banner-Desktop-Week-2.webp'
import mobileBannerPalacio from '@images/Home/banners/Homepage-Banner-Mobile-Week-2.webp'
import bannerRedhot from '@images/Home/banners/Red-Hot-Gloss-Homepage-Banner-Desktop-W1.webp'
import mobileBannerRedhot from '@images/Home/banners/Red-Hot-Gloss-Homepage-Banner-Mobile-W1.webp'


import bannerMemorial from '@images/Home/banners/memorial-day-sale-desktop.webp'
import mobileBannerMemorial from '@images/Home/banners/memorial-day-sale-mobile.webp'

import bannerWish from '@images/Home/banners/wish-you-were-here-desktop.webp'
import mobileBannerWish from '@images/Home/banners/wish-you-were-here-mobile.webp'

import bannerCore from '@images/Home/banners/core-collection-desktop.webp'
import mobileBanneCore from '@images/Home/banners/core-collection-mobile.webp'

// sub banners
import subBanner from '@images/Home/sub-banners/summer-sale-2025-subbanner-desktop.webp'
import mobileSubBanner from '@images/Home/sub-banners/summer-sale-2025-subbanner-mobile.webp'


import coreSubBanner from '@images/Home/sub-banners/core-collection-desktop.webp'
import mobileCoreSubBanner from '@images/Home/sub-banners/core-collection-mobile.webp'


import shopTankinis from '@images/Home/shop-card-section/tankinis.webp'
import shopTextured from '@images/Home/shop-card-section/textured.webp'
import shopShorts from '@images/Home/shop-card-section/shop-shorts.jpg'
import shopSale from '@images/Home/shop-card-section/shop-sale.webp'

const HomePage = ({justIn, bestSellerCollection, homeCollection, featuredCollections}) => {
  const {
    quickBuyData,
    setQuickBuyData,
    addToBagClicked,
    setAddToBagClicked,
    isAddToCart,
    setIsAddToCart,
  } = useContext(QuickBuyContext)
  
	const [openQuickBuyModal, setOpenQuickBuyModal] = useState(false)
	const [product, setProduct] =  useState(null)

	useEffect(() => {
		if(quickBuyData)
			setOpenQuickBuyModal(true)
			setProduct(quickBuyData)
			setIsAddToCart(false)
	}, [quickBuyData])

	useEffect(() => {
		if(addToBagClicked)
			setOpenQuickBuyModal(true)
			setProduct(addToBagClicked)
			setIsAddToCart(true)
	}, [addToBagClicked])



	return (
		<React.Fragment>
			<CarouselBanner
				data={ process.env.GATSBY_STORE !== "PH" ? [
					/*
					#########################################################
					################### GLOBAL BANNERS ######################
					#########################################################
					*/
                    {   
						title: "Wish you were here", 
						image: bannerWish, 
						mobileImage: mobileBannerWish, 
						url: '/collections/all/', 
						imageOnly: true,
						altText: 'Wish you were here',
					},
                    {   
						title: "Memorial Day Sale", 
						image: bannerMemorial, 
						mobileImage: mobileBannerMemorial, 
						url: '/collections/memorial-day-sale/', 
						imageOnly: true,
						altText: 'Memorial Day Sale',
					},
                    {   
						title: "Core Collection", 
						image: bannerCore, 
						mobileImage: mobileBanneCore,
						url: '/collections/the-core-collection/', 
						imageOnly: true,
						altText: 'Core Collection Flash Sale',
					},
                    {   
						title: "Red Hot Gloss", 
						image: bannerRedhot, 
						mobileImage: mobileBannerRedhot, 
						url: '/collections/all', 
						imageOnly: true,
						altText: 'Turn up the heat this summer',
					},
					{   
						title: "Palacio Del Sol", 
						image: bannerPalacio, 
						mobileImage: mobileBannerPalacio, 
						url: '/collections/the-palacio-del-sol-collection', 
						imageOnly: true,
						altText: 'Wherever the sun takes you',
					},
					
					
				] : [
					/*
					#########################################################
					##################### PH BANNERS ########################
					#########################################################
					*/
                    {   
						title: "Wish you were here", 
						image: bannerWish, 
						mobileImage: mobileBannerWish, 
						url: '/collections/all/', 
						imageOnly: true,
						altText: 'Wish you were here',
					},
					
					{   
						title: "Red Hot Gloss", 
						image: bannerRedhot, 
						mobileImage: mobileBannerRedhot, 
						url: '/collections/the-red-hot-gloss-collection', 
						imageOnly: true,
						altText: 'Turn up the heat this summer',
					},
					{   
						title: "Palacio Del Sol", 
						image: bannerPalacio, 
						mobileImage: mobileBannerPalacio, 
						url: '/collections/the-palacio-del-sol-collection', 
						imageOnly: true,
						altText: 'Wherever the sun takes you',
					},
					{   
						title: "Agua Fresca", 
						image: bannerBunny, 
						mobileImage: mobilebannerBunny, 
						url: '/collections/the-agua-fresca-collection/', 
						imageOnly: true,
						altText: 'For your stuffed bunny boos',
					},
                    {   
						title: "Henna", 
						image: bannerHenna, 
						mobileImage: mobileBannerHenna, 
						url: '/collections/the-henna-collection', 
						imageOnly: true,
						altText: 'Grounded in nature, made for the sun',
					},
				]}
			/>

			<div className="px-4">
				<JustInSection justIn={justIn} bestSellerCollection={bestSellerCollection} />

				<div className='py-6 w-full max-container'>
					{process.env.GATSBY_STORE === "PH" ? (
						<Link to='/collections/3500-sets'>
							<img className='w-full hidden md:block' src={`/.netlify/images?url=${subBanner}`} alt='25% Sale' loading='lazy' />
							<img className='w-full block md:hidden' src={`/.netlify/images?url=${mobileSubBanner}`} alt='25% Sale' loading='lazy' />
						</Link>
					) : (
						<Link to='/collections/the-core-collection/'>
							<img className='w-full hidden md:block' src={`/.netlify/images?url=${coreSubBanner}`} alt='Studio to Sea' loading='lazy' />
							<img className='w-full block md:hidden' src={`/.netlify/images?url=${mobileCoreSubBanner}`} alt='Studio to Sea' loading='lazy' />
						</Link>
					)}
				</div>
                {
                    /*
                
				<section className="max-container mt-8 grid grid-cols-4 justify-between gap-4 xl:px-0">
					<DisplayCard
						data={{
							image: shopTankinis,
							description:
							`The perfect mix of cute and sexy. They don’t call it "tankini summer" for no reason.`,
							buttonLabel: "SHOP TANKINIS",
							title: "shop-tankinis",
							handle: "tankinis",
						}}
						cardStyles={'displaycard-default w-auto md:max-w-[340px] col-span-2 lg:col-span-1 flex flex-col justify-between mx-auto'}
						imageClass={'h-full w-full max-h-[160px] md:max-h-none md:w-auto md:h-[350px] lg:h-[240px] xl:h-[350px] object-cover'}
						ariaLabel={'SHOP TANKINIS'}
					/>

					<DisplayCard
						data={{
							image: shopTextured,
							description:
							"From pointelle to jacquards, and smocked to shimmers, your favorite textured bikinis are right at your fingertips.",
							buttonLabel: "SHOP TEXTURED SWIM",
							title: "shop-textured-swim",
							handle: "the-textured-collection",
						}}
						cardStyles={'displaycard-default w-auto md:max-w-[340px] col-span-2 lg:col-span-1 flex flex-col justify-between mx-auto'}
						imageClass={'h-[160px] w-full md:w-auto md:h-[350px] lg:h-[240px] xl:h-[350px] object-cover'}
						ariaLabel={'SHOP TEXTURED SWIM'}
					/>

					<DisplayCard
						data={{
							image: shopShorts,
							description:
							"Our best kept secret: ultra-comfy swim shorts. Made with durable mesh fabric, they might even be better than our bikinis. You heard it first here.",
							buttonLabel: "SHOP SWIM SHORTS",
							title: "shop-swim-shorts",
							handle: "swim-shorts",
						}}
						cardStyles={'displaycard-default w-auto md:max-w-[340px] col-span-2 lg:col-span-1 flex flex-col justify-between mx-auto'}
						imageClass={'h-[160px] w-full md:w-auto md:h-[350px] lg:h-[240px] xl:h-[350px] object-cover'}
						ariaLabel={'SHOP SWIM SHORTS'}
					/>

					<DisplayCard
						data={{
							image: shopSale,
							description: <>
							SALE MARKDOWNS<br />Your favorite swim styles for less.
							</>,
							buttonLabel: "SHOP UP TO 30% OFF",
							title: "shop-sale",
							handle: "sale",
						}}
						cardStyles={'displaycard-default w-auto md:max-w-[340px] col-span-2 lg:col-span-1 flex flex-col justify-between mx-auto'}
						imageClass={'h-[160px] w-full md:w-auto md:h-[350px] lg:h-[240px] xl:h-[350px] object-cover'}
						ariaLabel={'SHOP UP TO 30% OFF'}
					/>
				</section>
                    */
                }

				<FeaturedSection homeCollection={homeCollection} />
				<CollectionSection featuredCollections={featuredCollections} />
				<LookBooksSection data={{}} />
				<DiscoverSection data={{}} />
				<SuitYourselfSection hideHeader />
			</div>

			<QuickBuyModal 
				isOpen={openQuickBuyModal}
				onClose={() => {
					setQuickBuyData(null)
					setOpenQuickBuyModal(false)
					setAddToBagClicked(null)
					setIsAddToCart(false)
				}}
				data={product}
				isAddToCart={isAddToCart}
			/> 


			{/* <div className="hidden lg:block">
			<img className="w-100 h-auto" src={imgSuitYourself} alt='suit yourself' />
			</div> */}
		</React.Fragment>
	);
}

export default HomePage